import React, { ReactNode, useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { useSessionContext } from '../../session/SessionContext';
import { useAuth0 } from '@auth0/auth0-react';

interface HeaderProps {
  /** Optional content to render in the center region */
  center?: ReactNode;
}

const Header: React.FC<HeaderProps> = ({ center }) => {
  const { context } = useSessionContext();
  const { user, logout } = useAuth0();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const userEmail = user?.email;

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    }
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [dropdownOpen]);

  return (
    <header className="header">
      <div className="header-left">
        <Link to="/" className="header-title">
          Mitoflux Rx
        </Link>
      </div>
      <div className="header-center"></div>
      {/* Render the center slot if provided */}
      {center && <div className="header-center">{center}</div>}

      <div className="header-right">
        <div className="user-profile" ref={dropdownRef}>
          <span className="user-name">{userEmail}</span>
          <button
            type="button"
            className="user-avatar-button"
            aria-label="User menu"
            aria-expanded={dropdownOpen}
            onClick={() => setDropdownOpen((prev) => !prev)}
          >
            <svg
              className="user-avatar-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
              aria-hidden="true"
            >
              <path d="M240 192C240 147.8 275.8 112 320 112C364.2 112 400 147.8 400 192C400 236.2 364.2 272 320 272C275.8 272 240 236.2 240 192zM448 192C448 121.3 390.7 64 320 64C249.3 64 192 121.3 192 192C192 262.7 249.3 320 320 320C390.7 320 448 262.7 448 192zM144 544C144 473.3 201.3 416 272 416L368 416C438.7 416 496 473.3 496 544L496 552C496 565.3 506.7 576 520 576C533.3 576 544 565.3 544 552L544 544C544 446.8 465.2 368 368 368L272 368C174.8 368 96 446.8 96 544L96 552C96 565.3 106.7 576 120 576C133.3 576 144 565.3 144 552L144 544z" />
            </svg>
          </button>
          {dropdownOpen && (
            <div className="user-dropdown">
              <button
                type="button"
                className="user-dropdown-item"
                onClick={() => {
                  setDropdownOpen(false);
                  logout({ logoutParams: { returnTo: window.location.origin } });
                }}
              >
                Skrá út
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
